import React from 'react'

const ErrorMessage = ({children,className}) => {
  return (
    <div className={`text-red-600 text-left ${className} `}>{children}</div>
  )
}

export default ErrorMessage